import ApiService from '../utils/apiService';
import {Loading,Message,MessageBox  } from 'element-ui';

const MessageService = {
    // 封装常用的消息提示方法
    success(msg) {
        Message({
            message: msg,
            type: 'success',
        });
    },
    error(msg) {
        Message({
            message: msg,
            type: 'error',
            offset:250,
        });
    },
    warning(msg) {
        Message({
            message: msg,
            type: 'warning',
        });
    },
    info(msg) {
        Message({
            message: msg,
            type: 'info',
        });
    },
    loading(){
      return Loading.service({
        lock: true,
        text: 'Loading...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    closeLoading(loadingInstance)
    {
      loadingInstance.close();
    },
    alert(message, title,onConfirm, onClose,type='success') {
      MessageBox.alert(message, title, {
        confirmButtonText: '确认',
        type: type,
      }).then(() => {
        if (typeof onConfirm === 'function') onConfirm();
      }).catch(() => {
        if (typeof onClose === 'function') onClose();
      });
    },
    confirm(message, onConfirm, onCancel) {
      MessageBox.confirm(message, '请确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (typeof onConfirm === 'function') onConfirm();
      }).catch(() => {
        if (typeof onCancel === 'function') onCancel();
      });
    },
    prompt(message, title, value = '', onConfirm, onCancel) {
      MessageBox.prompt(message, title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: value,
          inputPattern: /^.+$/, 
          inputErrorMessage: '输入内容不能为空',
      }).then(({value}) => {
          if (typeof onConfirm === 'function') onConfirm(value);
      }).catch(() => {
          if (typeof onCancel === 'function') onCancel();
      });
  },
};

const GlobalServices = {
    install(Vue) {
        Vue.prototype.$ApiService = ApiService;
        Vue.prototype.$MessageService = MessageService;
    }
};

export default GlobalServices;
